// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateModalVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isConfirmationModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_CONFIRMATION_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/reducers/confirmation-modal.js